<template>
  <InteractionStep :disabled-next="false"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-welcome">
        <div class="step-welcome__text text" style="margin-top: -1.5rem;">
          <p class="_accent">
            {{ $tInteraction('welcome_text_accent') }}
          </p>
        </div>
        <picture class="step-welcome__img">
          <img src="../../../assets/img/interaction-step-welcome.jpg"
               :alt="$tInteraction('Congratulations, you got the job!')">
        </picture>
        <div class="step-welcome__text text">
          <p>
            {{ $tInteraction('welcome_text_1') }}
            <template v-if="country"><span class="_accent">{{
                country
              }}</span>,
            </template>
            {{ $tInteraction('welcome_text_1.2') }}
          </p>
        </div>

        <div class="step-welcome__vacancy-info vacancy-info">
          <router-link-modified :to="{ name: 'company-info', params: { companySlug: employerProfile.slug }}"
                                class="vacancy-info__logo-wrap">
            <v-lazy-image v-if="employerProfile && employerProfile.company_logo"
                          use-picture
                          :src="employerProfile.company_logo"
                          :srcset="employerProfile.company_logo_webp">
              <source :srcset="employerProfile.company_logo_webp"
                      type="image/webp">
            </v-lazy-image>
            <BaseSvg v-else name="ico-avatar"/>
          </router-link-modified>
          <div class="vacancy-info__content">
            <div class="vacancy-info__top">
              <router-link-modified :to="{ name: 'company-info', params: { companySlug: employerProfile.slug }}"
                                    class="vacancy-info__employer">
                <abbr
                    v-if="employerProfile && (employerProfile.short_name || employerProfile.name)">{{
                    employerProfile && (employerProfile.short_name || employerProfile.name)
                  }}</abbr>
                <abbr v-else>{{ $tVacancy('No name') }}</abbr>
                <BaseSvg name="ico-check-outline"
                         class="vacancy-info__employer-badge"/>
              </router-link-modified>

              <div v-if="vacancy[3].work_place_city"
                   class="vacancy-info__location d-xs-none">
                <BaseSvg name="ico-map-marker"/>
                <span>{{ vacancy[3].work_place_city.name }}</span>
              </div>
            </div>

            <router-link-modified :to="{name: 'vacancy', params: {vacancyId: vacancy.slug}}"
                                  class="vacancy-info__name">
              {{ vacancy[1].name }}
            </router-link-modified>

            <div v-if="vacancy[3].work_place_city"
                 class="vacancy-info__mob-row d-none d-xs-block">
              <div class="vacancy-info__location">
                <BaseSvg name="ico-map-marker"/>
                <span>{{ vacancy[3].work_place_city.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="step-welcome__text text">
          <p>{{ $tInteraction(secondTextKey) }} <span class="_accent">{{ $tInteraction(secondTextKey2) }}</span>.
            <template v-if="workPeriods">{{ $tInteraction('welcome_text_2.2') }} <span
                class="_accent">{{ $tInteraction(workPeriods) }}</span>.
            </template>
          </p>
        </div>

        <div v-if="employmentType !== EMPLOYMENT_TYPE_CUSTOM" class="step-welcome__be-ready be-ready">
          <h4 class="be-ready__title">{{ $tInteraction('Be ready') }}:</h4>

          <ul v-if="employmentType === EMPLOYMENT_TYPE_WORK_VISA" class="be-ready__list">
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_1_work_visa') }}</div>
              <div v-if="$tInteraction('be_ready_1.2_work_visa') !== 'be_ready_1.2_work_visa'"
                   class="_small">
                {{ $tInteraction('be_ready_1.2_work_visa') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_2_work_visa') }}</div>
              <div v-if="$tInteraction('be_ready_2.2_work_visa') !== 'be_ready_2.2_work_visa'"
                   class="_small">
                {{ $tInteraction('be_ready_2.2_work_visa') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_3_work_visa') }}</div>
              <div v-if="$tInteraction('be_ready_3.2_work_visa') !== 'be_ready_3.2_work_visa'"
                   class="_small">
                {{ $tInteraction('be_ready_3.2_work_visa') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_4_work_visa') }}</div>
              <div v-if="$tInteraction('be_ready_4.2_work_visa') !== 'be_ready_4.2_work_visa'"
                   class="_small">
                {{ $tInteraction('be_ready_4.2_work_visa') }}
              </div>
            </li>
            <!--            <li class="be-ready__list-item">-->
            <!--              <div>{{ $tInteraction('be_ready_5_work_visa') }}</div>-->
            <!--              <div v-if="$tInteraction('be_ready_5.2_work_visa') !== 'be_ready_5.2_work_visa'"-->
            <!--                   class="_small">-->
            <!--                {{ $tInteraction('be_ready_5.2_work_visa') }}-->
            <!--              </div>-->
            <!--            </li>-->
          </ul>
          <ul v-else-if="employmentType === EMPLOYMENT_TYPE_SEASON_VISA" class="be-ready__list">
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_1_season_visa') }}</div>
              <div v-if="$tInteraction('be_ready_1.2_season_visa') !== 'be_ready_1.2_season_visa'"
                   class="_small">
                {{ $tInteraction('be_ready_1.2_season_visa') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_2_season_visa') }}</div>
              <div v-if="$tInteraction('be_ready_2.2_season_visa') !== 'be_ready_2.2_season_visa'"
                   class="_small">
                {{ $tInteraction('be_ready_2.2_season_visa') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_3_season_visa') }}</div>
              <div v-if="$tInteraction('be_ready_3.2_season_visa') !== 'be_ready_3.2_season_visa'"
                   class="_small">
                {{ $tInteraction('be_ready_3.2_season_visa') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_4_season_visa') }}</div>
              <div v-if="$tInteraction('be_ready_4.2_season_visa') !== 'be_ready_4.2_season_visa'"
                   class="_small">
                {{ $tInteraction('be_ready_4.2_season_visa') }}
              </div>
            </li>
            <!--            <li class="be-ready__list-item">-->
            <!--              <div>{{ $tInteraction('be_ready_5_season_visa') }}</div>-->
            <!--              <div v-if="$tInteraction('be_ready_5.2_season_visa') !== 'be_ready_5.2_season_visa'"-->
            <!--                   class="_small">-->
            <!--                {{ $tInteraction('be_ready_5.2_season_visa') }}-->
            <!--              </div>-->
            <!--            </li>-->
          </ul>
          <ul v-else-if="employmentType === EMPLOYMENT_TYPE_BIOMETRIC" class="be-ready__list">
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_1_biometric') }}</div>
              <div v-if="$tInteraction('be_ready_1.2_biometric') !== 'be_ready_1.2_biometric'"
                   class="_small">
                {{ $tInteraction('be_ready_1.2_biometric') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_2_biometric') }}</div>
              <div v-if="$tInteraction('be_ready_2.2_biometric') !== 'be_ready_2.2_biometric'"
                   class="_small">
                {{ $tInteraction('be_ready_2.2_biometric') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_3_biometric') }}</div>
              <div v-if="$tInteraction('be_ready_3.2_biometric') !== 'be_ready_3.2_biometric'"
                   class="_small">
                {{ $tInteraction('be_ready_3.2_biometric') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_4_biometric') }}</div>
              <div v-if="$tInteraction('be_ready_4.2_biometric') !== 'be_ready_4.2_biometric'"
                   class="_small">
                {{ $tInteraction('be_ready_4.2_biometric') }}
              </div>
            </li>
            <li class="be-ready__list-item">
              <div>{{ $tInteraction('be_ready_5_biometric') }}</div>
              <div v-if="$tInteraction('be_ready_5.2_biometric') !== 'be_ready_5.2_biometric'"
                   class="_small">
                {{ $tInteraction('be_ready_5.2_biometric') }}
              </div>
            </li>
          </ul>
        </div>

        <div class="step-welcome__text text">
          <p>{{ $tInteraction('welcome_text_3') }}</p>
        </div>
      </div>

      <BaseAlert :value="error" class="step-contract__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '@/axios'
  import {
    EMPLOYMENT_TYPE_WORK_VISA,
    EMPLOYMENT_TYPE_SEASON_VISA,
    EMPLOYMENT_TYPE_BIOMETRIC,
    EMPLOYMENT_TYPE_CUSTOM
  } from '@/constants/interaction'
  import interactionStepMixin from '@/mixins/interactionStepMixin'
  import InteractionStep from '@/components/interactions/InteractionStep'

  const polandVariants = {
    ua: 'Польщі',
    ru: 'Польши',
    pl: 'Polski',
  }

  export default {
    name: 'InteractionStepWelcome',
    mixins: [interactionStepMixin],
    components: {InteractionStep},
    props: {
      visa: Boolean,
      biometric: Boolean,
    },
    data() {
      return {
        pendingSave: false,
        error: null,
        EMPLOYMENT_TYPE_WORK_VISA,
        EMPLOYMENT_TYPE_SEASON_VISA,
        EMPLOYMENT_TYPE_BIOMETRIC,
        EMPLOYMENT_TYPE_CUSTOM,
      }
    },
    computed: {
      vacancy() {
        return this.$store.state.interaction.vacancy
      },
      employerProfile() {
        return this.vacancy.employer.employerProfile || {}
      },
      employmentType() {
        return this.$store.state.interaction.data.type_of_employment
      },
      country() {
        const country = this.vacancy[3].work_place_country
        if(!country) {
          return null
        }

        const currentLocale = this.$store.state.currentLocale

        if(country.id === 165) {
          return polandVariants[currentLocale] || country.name
        }

        return country.name
      },
      secondTextKey() {
        switch (this.employmentType) {
          case EMPLOYMENT_TYPE_WORK_VISA:
            return 'welcome_text_2_work_visa'
          case EMPLOYMENT_TYPE_SEASON_VISA:
            return 'welcome_text_2_season_visa'
          case EMPLOYMENT_TYPE_BIOMETRIC:
            return 'welcome_text_2_biometric'
        }

        return null
      },
      secondTextKey2() {
        switch (this.employmentType) {
          case EMPLOYMENT_TYPE_WORK_VISA:
            return 'by work visa'
          case EMPLOYMENT_TYPE_SEASON_VISA:
            return 'by season visa'
          case EMPLOYMENT_TYPE_BIOMETRIC:
            return 'by biometric'
        }

        return null
      },
      workPeriods() {
        switch (this.employmentType) {
          case EMPLOYMENT_TYPE_WORK_VISA:
            return 'work_period_visa'
          case EMPLOYMENT_TYPE_SEASON_VISA:
            return 'work_period_season_visa'
          case EMPLOYMENT_TYPE_BIOMETRIC:
            return 'work_period_by_biometric'
        }

        return null
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, {
          start_step: 1
        }).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
    }
  }
</script>

<style>

</style>
